import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import OfferProductCard from "./OfferProductCard";
import axios from "axios";
import "swiper/css";
import "swiper/css/pagination";

export default function OfferSwiper() {
  const [offerProducts, setOfferProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchDiscountProducts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/discounts`);
        
        if (response.data.discountedProducts?.length > 0) {
          const products = response.data.discountedProducts.map(product => {
            const priceValues = Object.values(product.prices).map(price => parseInt(price));
            const maxOriginalPrice = Math.max(...priceValues);
            
            let discountedPrice, discount;
            
            if (product.discountedPrices) {
              const discountedPriceValues = Object.values(product.discountedPrices).map(price => parseFloat(price));
              discountedPrice = Math.max(...discountedPriceValues);
              discount = Math.round((1 - discountedPrice / maxOriginalPrice) * 100);
            } else {
              discountedPrice = maxOriginalPrice;
              discount = 0;
            }

            return {
              id: product.id,
              image: product.images[0],
              name: product.name,
              originalPrice: maxOriginalPrice,
              discountedPrice: discountedPrice,
              discount: discount,
              offerType: product.offerType
            };
          });
          setOfferProducts(products);
        } else {
          setOfferProducts([]);
        }
      } catch (err) {
        console.error("Error fetching discount products:", err);
        setOfferProducts([]); // Treat errors the same as no offers
      } finally {
        setLoading(false);
      }
    };
    
    fetchDiscountProducts();
  }, [API_BASE_URL]);

  if (loading) {
    return <div className="w-full px-4 md:px-8 py-6 text-center">Loading offers...</div>;
  }

  if (offerProducts.length === 0) {
    return (
      <div className="w-full px-4 md:px-8 py-6 text-center">
        <div className="text-gray-500 mb-4">No offers available at this time</div>
        <p className="text-gray-400 text-sm mb-4">
          Check back soon for exciting deals and discounts
        </p>
        <button 
          onClick={() => window.location.reload()}
          className="bg-[#D4AF37] text-black px-4 py-2 rounded-sm text-sm font-medium hover:bg-[#C19B2E] transition-all"
        >
          Refresh
        </button>
      </div>
    );
  }

  return (
    <div className="w-full px-4 md:px-8 py-6 relative">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} w-2 h-2 bg-[#D4AF37] rounded-full mx-1"></span>`;
          },
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        breakpoints={{
          480: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 25 },
          1280: { slidesPerView: 4, spaceBetween: 30 },
        }}
        className="offer-swiper"
      >
        {offerProducts.map((product, index) => (
          <SwiperSlide key={index} className="py-4">
            <div className="flex justify-center">
              <OfferProductCard product={product} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}